module.exports = __webpack_public_path__ + "static/media/consume.4cdd399c.png";